$('html').on('click', 'a.colorbox, a.p-main-image.cbox', function (e) {
    e.preventDefault();

    // --- ZJISTI AKTIVNÍ INDEX ---
    var activeIdx = 0;
    $('.p-thumbnails .p-thumbnail').each(function (i) {
        if ($(this).hasClass('highlighted')) {
            activeIdx = i;
        }
    });

    // --- OTEVŘI NAŠI GALERII ---
    $('.cbox-gal').eq(activeIdx).click();
});

// --- SBÍRÁNÍ OBRÁZKŮ ---
var images = [];
$('.cbox-gal').each(function () {
    images.push({
        href: $(this).attr('href'),
        alt: $(this).data('alt')
    });
});

// --- FUNKCE PRO THUMBNAILY ---
function renderThumbnails() {
    $('#cboxContent .cbox-thumbs').remove();

    var currentSrc = $('#cboxPhoto').attr('src') || '';
    var thumbsHtml = '<div class="cbox-thumbs"><div class="cbox-thumbs-inner">';

    $.each(images, function (i, img) {
        var imgFile = img.href.split('/big/')[1];
        var thumbSrc = img.href.replace('/big/', '/related/');
        thumbsHtml += '<a href="#" class="cbox-thumb' + '" data-index="' + i + '">'
            + '<img src="' + thumbSrc + '" alt="' + img.alt + '">'
            + '</a>';
    });

    thumbsHtml += '</div></div>';
    $('#cboxContent').append(thumbsHtml);

    $('#cboxContent .cbox-thumb').on('click', function (e) {
        e.preventDefault();
        var idx = $(this).data('index');
        $('.cbox-gal').eq(idx).click();
    });

    var $slider = $("#cboxContent .cbox-thumbs-inner");
    if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
            slidesToShow: 7,
            slidesToScroll: 1,
            centerMode: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: true,
            arrows: true,
            infinite: false,
            variableWidth: true,
            adaptiveHeight: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 7,
                        slidesToScroll: 1,
                        dots: false,
                        variableWidth: false
                    }
                },
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        dots: false
                    }
                }
            ]
        });
    }
}
function updateActiveThumb() {
    // najdeme všechny thumby
    var $thumbs = $('.cbox-thumb');
    $thumbs.removeClass('active');

    // aktuální obrázek (z načteného obsahu Colorboxu)
    var $currentImg = $('#cboxLoadedContent img');
    var currentAlt = $currentImg.attr('alt') || '';

    // projdeme všechny thumby a porovnáme podle alt atributu
    $thumbs.each(function () {
        var $thumbImg = $(this).find('img');
        var thumbAlt = $thumbImg.attr('alt') || '';

        if (thumbAlt === currentAlt) {
            $(this).addClass('active');

            if ($('.cbox-thumbs-inner').hasClass('slick-initialized')) {
                var idx = $(this).data('index');
                $('.cbox-thumbs-inner').slick('slickGoTo', idx);
            }
        }
    });
}
// --- INICIALIZACE COLORBOX ---
$('.cbox-gal').colorbox({
    rel: 'gallery',
    maxWidth: '90%',
    maxHeight: '75%',
    current: '{current} / {total}',
    title: function () {
        return $(this).data('alt');
    },
    onComplete: function () {

        if (!$('#cboxContent .cbox-thumbs').length) {
            renderThumbnails();
        }

        setTimeout(function () {
            updateActiveThumb();
        }, 80);

    }

});











if ($('.p-thumbnails-wrapper .p-thumbnails-inner').length) {


    var $thumbLinks = $('.p-thumbnails-inner div').first().find('a.p-thumbnail');
    var visibleCount = window.innerWidth >= 992 ? 5 : 3;

    /*if ($thumbLinks.length > visibleCount) {
        var otherCount = $thumbLinks.length - visibleCount - 1;

        $thumbLinks.closest('div').append(
            '<a href="#" class="special"><span class="number">Zobrazit další (' + otherCount + ')</span></a>'
        );

        addListenerBtn();
    }*/

    function addListenerBtn() {
        $('.p-thumbnails-inner').on('click', 'a.special', function (e) {
            e.preventDefault();

            // --- ZJISTI AKTIVNÍ INDEX ---
            var activeIdx = 0;
            $('.p-thumbnails .p-thumbnail').each(function (i) {
                if ($(this).hasClass('highlighted')) {
                    activeIdx = i;
                }
            });

            // --- OTEVŘI NAŠI GALERII ---
            $('.cbox-gal').eq(activeIdx).click();
        });
    }



    $('.p-image-wrapper').addClass('haveThumbnails');
   // $('.p-image-wrapper .p-image').append('<span class="arrow-prev arrow"></span><span class="arrow-next arrow  "></span>');
   /* $('body').on('click', '.arrow-prev, .arrow-next', function () {
        var thumbnails = $('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image');
        var highlightedThumbnail = $('.p-thumbnails-inner').find('a.highlighted');
        var isNext = $(this).hasClass('arrow-next');
        var totalThumbnails = thumbnails.length;
        var currentIndex = thumbnails.index(highlightedThumbnail);
        thumbnails.removeClass('highlighted');
        if (highlightedThumbnail.length === 0) {

            highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();

        } else {

            currentIndex = isNext ? (currentIndex + 1) % totalThumbnails : (currentIndex - 1 + totalThumbnails) % totalThumbnails;

            highlightedThumbnail = thumbnails.eq(currentIndex);

        }
        highlightedThumbnail.addClass('highlighted');
        setTimeout(function () {

            updateMainImage(highlightedThumbnail);

        }, 10);
    });
    function updateMainImage(highlightedThumbnail) {
        var findHighlighted = highlightedThumbnail.attr('href');
        var findHighlightedAlt = highlightedThumbnail.find('img').attr('alt');
        $('.p-image a.p-main-image').attr('href', findHighlighted).find('img').attr({ 'src': findHighlighted, 'alt': findHighlightedAlt });
    }*/
}